import API from 'services/TAPS_API/index';

export default function get3NDFLPdfName(notificationId) {
  return API.request({
    method: 'GET',
    url: `/need-to-provide3-ndfl/pdf`,
    params: {
      notificationId,
    },
  });
}
